module.exports = __webpack_public_path__ + "static/media/prompt-notifications.37696912.svg";